// extracted by mini-css-extract-plugin
export default {"tab-header":"TabHeader_tab-header__2MTx7","tab-header__title":"TabHeader_tab-header__title__3cBRW","tab-header__description":"TabHeader_tab-header__description__3bf2H"};